
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/whitepaper/[slug]",
      function () {
        return require("private-next-pages/blog/whitepaper/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/whitepaper/[slug]"])
      });
    }
  